import React from 'react';
import './AdminOrderData.css';
import deadline from '../../../../image/deadline.svg'
import iconclose from '../../../../image/iconclose.svg'
var moment = require('moment');


const AdminOrderData = (props) => {

    return (
        <div className="AdminOrderData">
            <div className="row text-center">
                <div className="col-3 border-right p-2">
                    <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order ID : </span> {props.state.ordernumber}</p>
                </div>
                <div className="col-4 border-right p-2">
                    <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order Price : </span> {props.state.totalPrice} EGP</p>

                </div>
                <div className="col-5 p-2">
                    <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order date : </span>{(props.state.date? moment(props.state.date).format("ll") :'')}</p>
                </div>
            </div>
            <div className="row p-lg-3">
                <div className="col-lg-8">

                    <img className="mx-4" src={deadline} alt="deadline" />
                    <span className="fontsize4  font-weight-bold mt-2">{(props.state.pickupdate? moment(props.state.pickupdate).format("ll") :'')}</span>
                </div>

                <div className="col-lg-4 text-right py-3">
                    <p className=" font-weight-bold ">Product quantity:<span className="ml-3  font-weight-bold ">{props.state.quantity} items</span></p>
                </div>

            </div>
            {/* old date */}
            {(props.state.failedstatus === 4 ? <div>
                <h3 className=" fontsize9 font-weight-bold">Old Receiver details</h3>
                <ul className="timeline row">
                    <li className="bg-white  col-lg-5 mx-auto lileft pointer" data-toggle="modal" data-target=".bd-example-modal-lg">
                        <div className=" py-3 mx-5 my-2 ">
                            <p className="fontsize11 bluecolor">Pick up</p>
                            <p className="fontsize11 m-0">{props.state.pickupaddress_name}</p>
                        </div>
                    </li>
                    <li className="bg-white col-lg-5 mx-auto liright">
                        <div className=" py-3 mx-5 my-2">
                            <p className="fontsize11 bluecolor">Drop off</p>
                            <p className="fontsize11 m-0">{props.state.dropoffLocationnameold}</p>
                        </div>
                    </li>
                </ul>
                <div className="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">

                        <div className="modal-content  p-3">
                            <div className="text-right">
                                <img className="mx-4 pointer text-right" src={iconclose} alt="iconclose" data-dismiss="modal" aria-label="Close" />
                            </div>
                            <p className="fontsize11 text-center font-weight-bold">Delivery details</p>

                            <div className="row border m-3 p-3 rounded">
                                <p className="fontsize11 col-md-3 bluecolor ">Address</p><p className="fontsize11 col-md-9">{props.state.pickupaddress_name}</p>
                                <p className="fontsize11 col-md-3 bluecolor ">Address Details </p><p className="fontsize11 col-md-9">{props.state.pickupaddress_alias}</p>
                                <p className="fontsize11 col-md-3 bluecolor ">Business Owner Name </p><p className="fontsize11 col-md-9">{props.state.ownerData_name}</p>
                                <p className="fontsize11 col-md-3 bluecolor">Phone number </p><p className="fontsize11 col-md-9">{props.state.ownerData_phone}</p>

                            </div>
                        </div>
                    </div>
                </div>
                {/* <p className="fontsize11 "> Product quantity: {props.state.quantity} items</p> */}
                {/* <hr /> */}
                <div className="row pt-3">
                    <div className="row col-12 ">
                        <div className="col-md-6 my-2">
                            <p className=" fontsize12 text-muted">Reciever</p>
                            <p className="fontsize11 font-weight-bold">{props.state.recivernameold}</p>

                        </div>
                        <div className="col-md-6   my-2">
                            <p className=" fontsize12 text-muted">Phone number</p>
                            <p className="fontsize11 font-weight-bold">{props.state.reciverphoneold}</p>

                        </div>

                    </div>
                    
                </div>
                <hr />

            </div> : '')}
            {/* new date */}
            <h3 className=" fontsize9 font-weight-bold">Receiver details</h3>
            <ul className="timeline row">
                <li className="bg-white  col-lg-5 mx-auto lileft pointer" data-toggle="modal" data-target=".bd-example-modal-lg">
                    <div className=" py-3 mx-5 my-2 ">
                        <p className="fontsize11 bluecolor">Pick up</p>
                        <p className="fontsize11 m-0">{props.state.pickupaddress_name}</p>
                    </div>
                </li>
                <li className="bg-white col-lg-5 mx-auto liright">
                    <div className=" py-3 mx-5 my-2">
                        <p className="fontsize11 bluecolor">Drop off</p>
                        <p className="fontsize11 m-0">{props.state.dropoffLocationnamenew}</p>
                    </div>
                </li>
            </ul>
            <div className="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">

                    <div className="modal-content  p-3">
                        <div className="text-right">
                            <img className="mx-4 pointer text-right" src={iconclose} alt="iconclose" data-dismiss="modal" aria-label="Close" />
                        </div>
                        <p className="fontsize11 text-center font-weight-bold">Delivery details</p>

                        <div className="row border m-3 p-3 rounded">
                            <p className="fontsize11 col-md-3 bluecolor ">Address</p><p className="fontsize11 col-md-9">{props.state.pickupaddress_name}</p>
                            <p className="fontsize11 col-md-3 bluecolor ">Address Details </p><p className="fontsize11 col-md-9">{props.state.pickupaddress_alias}</p>
                            <p className="fontsize11 col-md-3 bluecolor ">Business Owner Name </p><p className="fontsize11 col-md-9">{props.state.ownerData_name}</p>
                            <p className="fontsize11 col-md-3 bluecolor">Phone number </p><p className="fontsize11 col-md-9">{props.state.ownerData_phone}</p>

                        </div>
                    </div>
                </div>
            </div>
            {/* <p className="fontsize11 "> Product quantity: {props.state.quantity} items</p> */}
            {/* <hr /> */}
            <div className="row pt-3">
                <div className="row col-lg-5 col-md-6  border-right">
                    <div className="col-12 my-2">
                        <p className=" fontsize12 text-muted">Reciever</p>
                        <p className="fontsize11 font-weight-bold">{props.state.recivernamenew}</p>

                    </div>
                    <div className="col-12  my-2">
                        <p className=" fontsize12 text-muted">Phone number</p>
                        <p className="fontsize11 font-weight-bold">{props.state.reciverphonenew}</p>

                    </div>

                </div>
                <div className="col-md-6">
                    <div className=" col-12 ">
                        <p className="fontsize12 text-muted">Delivery Note</p>
                        <p className="fontsize11 font-weight-bold">{props.state.deliverynote}</p>
                    </div>
                    {/* <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="Q"
                        style={{ width: 180 }}
                        value={props.state.qrcode}
                    /> */}
                </div>

                <p className="fontsize11 mb-0 col-12">Collect: <span className="fontsize4  font-weight-bold bluecolor ml-5">  {(props.state.amount ? props.state.amount : '0')}EGP  </span></p>

            </div>
            <hr />
            <div className="row stages">
                <div className="col-lg-4 col-sm-6 ">
                    <div className="dropdown text-center p-3" >
                        <button className="btn bg-light border selectdropdown badge-pill text-muted dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" disabled={(props.state.status === 1||props.state.status === 2 ? '' : 'disabled')} aria-haspopup="true" aria-expanded="false" >
                            {props.state.selectpickupcourier}
                        </button>
                        <div className="dropdown-menu  mt-1" aria-labelledby="dropdownMenuButton">
                            {
                                props.state.getnearstpickupcourier.map((x, i) => (
                                    <a key={i} className="dropdown-item pointer" onClick={props.Assignpickupcourier(x._id)}>{x.name}</a>
                                ))
                            }
                        </div>
                    </div>
                    <div className="dropdown text-center p-3">
                        <button className="btn bg-light border selectdropdown badge-pill text-muted dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" disabled={(props.state.status === 4&&props.state.failedstatus!==1||props.state.status === 5&&props.state.failedstatus!==1 ? '' : 'disabled')} aria-haspopup="true" aria-expanded="false">
                            {props.state.selectdeliverycourier}
                        </button>
                        <div className="dropdown-menu  mt-1" aria-labelledby="dropdownMenuButton">
                            {
                                props.state.getnearstdeliverycourier.map((x, i) => (
                                    <a key={i} className="dropdown-item pointer" onClick={props.Assigndeliverycourier(x._id)}>{x.name}</a>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div className=" col-lg-4 col-sm-6 text-center">
                    <p className={"badge-pill onestages border " + (props.state.status === 1 ? 'placed' : '')} >Placed</p>
                    <p className={"badge-pill onestages border " + (props.state.status === 2 ? 'assign-B' : '')}>Assigned</p>
                    <p className={"badge-pill onestages border " + (props.state.status === 3 ? 'pickedup' : '')}>pickedup</p>
                    <p className={"badge-pill onestages border " + (props.state.status === 4 ? 'warehouse' : '')}>warehouse</p>
                    <p className={"badge-pill onestages border " + (props.state.status === 5 ? 'assign-D' : '')}>Assigned</p>
                    <p className={"badge-pill onestages border " + (props.state.status === 6 ? 'O-F-delivery' : '')}>out for delivery</p>
                    <p className={"badge-pill  border " + (props.state.status === 7 ? 'delivered' : '')}>delivered</p>
                </div>
               
                <div className="col-lg-4 ">
                    {(props.state.failedstatus===1||props.state.status===8&&props.state.failedstatus===0||props.state.failedstatus===5?
                        <div className=" nothome text-center m-2 ">
                            <p className="fontsize12 m-0">Failed delivery note</p>
                            <p className="fontsize11 font-weight-bold m-0">{props.state.failedreason}</p>
                            {(props.state.failedstatus === 5?<p className="fontsize11 font-weight-bold m-0">We will try again to deliver the order to Receiver</p>:'')}
                        </div> : '')}
                        {(props.state.failedstatus===3?
                        <div className=" Retuned text-center m-2 ">
                            <p className="fontsize12 m-0">Returned</p>
                            <p className="fontsize11 font-weight-bold m-0">Client Returned package</p>
                        </div> : '')}
                        {(props.state.failedstatus===4?
                        <div className=" Retuned text-center m-2 ">
                            <p className="fontsize12 m-0">Replaced</p>
                            <p className="fontsize11 font-weight-bold m-0">Client Replaced package</p>
                        </div> : '')}
                </div>
                <hr />

            </div>
        </div>
    )

}
export default AdminOrderData;